// Regiao de Estudo
import api from '@/api';
import _ from 'lodash';
import moment from 'moment';
import { debug } from 'util';



export default function (data) {

  var STATE = {
    orders: [],
    products: [],
    members:{},
    teams:{},
    purshaceProducts:{},
    status:'',
    statusError:'',
  }

  return {

    namespaced: true,
    state: STATE,

    mutations: {

      setState: function (state, obj) {
          for(var k in obj){
            state[k] = obj[k]
          }
      },
    // {id: {id:0,purchaseProductId:0,infos:{}} }
      addMembers: function(state, members) {
         members = _.isArray(members) ? _.keyBy(members,'id') : members
         let membersFinal = {...state.members, ...members};
         state.members = membersFinal;
      },
      // {id: {id:0,purchaseProductId:0,infos:{}} }
      addTeams: function(state, teams  ) {
        teams = _.isArray(teams) ? _.keyBy(teams,'id') : teams
        let teamsFinal = {...state.teams, ...teams};
        state.teams = teamsFinal;
      },
      // {id:{id:0,orderId:0,productId:0,price:0}}
      addPurshaceProducts: function(state, purshaceProducts) {
         purshaceProducts = _.isArray(purshaceProducts) ? _.keyBy(purshaceProducts,'id') : purshaceProducts
         let purshaceProductsFinal = {...state.purshaceProducts, ...purshaceProducts};
         state.purshaceProducts = purshaceProductsFinal;
      },

      setPurchase:function(state,purchaseproducts){
          //normalize Purchase
          let members = [], 
              purshaceProducts = [], 
              products = [], 
              teams = [];

          if( !_.isArray(purchaseproducts) ) purchaseproducts = [purchaseproducts];
          
          for (let i = 0; i < purchaseproducts.length; i++) {
            let purchaseProduct = purchaseproducts[i];
            members = _.concat(members, purchaseProduct.members)
            teams = _.concat(teams, purchaseProduct.team)
            products = _.concat(products, purchaseProduct.product)
            delete purchaseProduct.product;
            delete purchaseProduct.members;
            delete purchaseProduct.teams;
            purshaceProducts.push(purchaseProduct)
          }
          members = _.keyBy(members,'id')
          teams = _.keyBy(teams,'id')
          purshaceProducts = _.keyBy(purshaceProducts,'id')
          products = _.keyBy(products,'id')

          state.members = members
          state.teams = teams
          state.purshaceProducts = purshaceProducts
          state.products = products
               
      },

      createNewOrder: function(state){
        var orders = [...state.orders];
        let id = _.uniqueId('new_order');
        orders.push( {id , orderDescription:'new shopping cart' } )
        state.currentOrderId = id;
        state.orders = orders;
        return id;
      },

      createPurshaseProduct:function(state, product){
          let members = {...state.members};
          let teams = {...state.teams};
          let purshaceProducts = {...state.purshaceProducts};
          let purchaseProductId = _.uniqueId('new_purshase_product');
         
          purshaceProducts[purchaseProductId] = { id:purchaseProductId, orderId:state.currentOrderId, productId:product.id, price:product.price }

          //create members and teams for this product
          let teamSize = product.teamDefinitions.size;
          if( !_.isEmpty(product.memberInfos) ){
            for (let i = 0; i < teamSize; i++) {
              let id = _.uniqueId('new_member');
              members[id] = { id, purchaseProductId, infos:{} }
            }
          }
          if( !_.isEmpty(product.teamInfos) ){
            let id = _.uniqueId('new_team');
            teams[id] = { id, purchaseProductId, infos:{} }
          }

          state.members = members;
          state.teams = teams;
          state.purshaceProducts = purshaceProducts
          
      },

      removePurchaseProduct:function(state, purshaseProduct){
        let purshaseProductId = _.get(purshaseProduct,'id',purshaseProduct)
        
        let members = {...state.members};
        let teams = {...state.teams};
        let purshaceProducts = {...state.purshaceProducts};

        //remove all members
        _.each(members,member=>{
          if(member.purshaseProductId == purshaseProductId){
            delete members[member.id];
          }
        })
        //remove all teams
        _.each(teams,team=>{
          if(team.purshaseProductId == purshaseProductId){
            delete teams[team.id];
          }
        })
        //remove the purchaseProduct
        delete purshaceProducts[purshaseProductId]

        state.members = members;
        state.teams = teams;
        state.purshaceProducts = purshaceProducts;

      },

      updateMemberInfo:function(state,{memberId, infos}){
        if(state.members[memberId]){
          state.members[memberId].infos = {...infos}
        }
      },

      updateTeamInfo:function(state,{teamId, infos}){
        if(state.teams[teamId]){
          state.teams[teamId].infos = {...infos}
        }
      },

    },

  
    actions: {

      loadMyRegistrations: async function (ctx, token) {

        ctx.commit( 'setState', {...STATE} )
        
        
        let purchases = await api.getJSONAsync('myRegistrations' )
        if(purchases.error){
          return false
        } else{
          console.log(purchases)
          ctx.commit( 'setPurchase' , purchases )
        }
        
      },



      loadEventRegistrations: async function (ctx, id) {

        ctx.commit( 'setState', {...STATE} )
        
        
        let purchases = await api.getJSONAsync('allRegistrations', {id:id} )
        if(purchases.error){
          return false
        } else{
          console.log(purchases)
          ctx.commit( 'setPurchase' , purchases )
        }
      },

      loadRegistrationsById: async function (ctx, id) {


        ctx.commit( 'setState', {...STATE} )
        //debugger;

        let purchases = await api.getJSONAsync('registrationsById',{id} )
        if(purchases.error || purchases == false){
          return false
        } else{
          console.log(purchases)
          ctx.commit( 'setPurchase' , purchases )
          return purchases
        }
      },



      markAsPayed: async function (ctx, id) {

        let purchases = await api.postJSONAsync('markPurchaseAsPayed',{id} )
        if(purchases.error || purchases == false){
          return false
        } else{
          console.log(purchases)
          ctx.dispatch('loadRegistrationsById',id)
          return purchases
        }
      },

      markAsCanceled: async function (ctx, id) {

        let purchases = await api.postJSONAsync('markPurchaseAsCanceled',{id} )
        if(purchases.error || purchases == false){
          return false
        } else{
          console.log(purchases)
          ctx.dispatch('loadRegistrationsById',id)
          return purchases
        }
      },

      markAsNotCanceled: async function (ctx, id) {

        let purchases = await api.postJSONAsync('markPurchaseAsNotCanceled',{id} )
        if(purchases.error || purchases == false){
          return false
        } else{
          console.log(purchases)
          ctx.dispatch('loadRegistrationsById',id)
          return purchases
        }
      },



      addProduct:function(ctx, productId){
        //check if thereIs a current order
        let currentOrder = ctx.getters.currentOrder;
        let orderID;
        if( ! currentOrder ){
          //if dontHave, create a new Order
          ctx.commit('createNewOrder');
          orderID = ctx.state.currentOrderId;
        }else{
          if(ctx.state.canChangeCurrentOrder){
            orderID = currentOrder.id
          }
        }

        if(!orderID) return new Error('Can change Current Order')
        let product = ctx.rootGetters['EventStore/getProductById'](productId)
        if(product){
          //add the product to this new order
          ctx.commit('addProduct',product)
        }else{
          return new Error('Product dont exists!')
        }

      },

      removeLastProductOfId:function(ctx, productId){
          let purshaseProducts = ctx.getters.purshaseProductsForCurrentOrder;
          // get let purshase with productId
          let purshaseProduct = _.findLast(purshaseProducts,{ productId })
          ctx.commit('removePurchaseProduct',purshaseProduct)
      },


      savePurchase:async function(ctx,id){

        let params = {}
        // params.buyer = ctx.getters.buyer;
        // params.order = ctx.getters.currentOrder;
        params.purshaseProducts = ctx.getters.purshaseProductById(id);
        //debugger;
        // params.eventId = ctx.rootGetters['EventStore/eventInfo'].id;
        // params.paymentInfo = ctx.getters.paymentInfo;
        // params.paymentOptionId = ctx.getters.paymentOptionSelected.id;
        // params.totalTax = ctx.state.totalTax;
        // params.clientId = ctx.rootGetters.user.id;
        let res;
        try{
          res = await api.postJSON('savePurchase',params)
        }catch(e){
          return { error:true, msg:e.response.data } ;
        }
        return res.data
      }

    },


    getters: {


      currentOrder: state => {
        var order = _.find(state.orders, o=> o.id = state.currentOrderId)
        if( order ){
          return order
        }else{
          return false
        }
      },

      currentOrderPaymentStatus: ( state, getters, rootState, rootGetters ) =>{
          let order = getters.currentOrder
          if(order){
            if(order.payedByAdmin){
              return 'payed'
            }
            return _.get(order,'paymentStatus',false)
          }else{
            return false
          }
      },


      myRegistrations: ( state, getters, rootState, rootGetters ) =>{
          
          let registrations =  _.map( state.purshaceProducts, purshaseProduct =>{
              purshaseProduct = {...purshaseProduct}
              purshaseProduct.members = getters.membersForPurshaseProduct(purshaseProduct.id)
              purshaseProduct.team = getters.teamForPurshaseProduct(purshaseProduct.id)

              if(purshaseProduct.payed==true || purshaseProduct.payedByAdmin==true  ){
                purshaseProduct._paymentStatus = "payed";
              }else{
                purshaseProduct._paymentStatus = purshaseProduct.paymentStatus
              }
              //debugger;
              let teamname = ""
              teamname = _.get(purshaseProduct,'team.[0].infos.nome-equipe',_.get(purshaseProduct,'team.[0].infos.nome',_.get(purshaseProduct,'team.[0].infos.name')));
             
              if( _.isEmpty(teamname) ){
                let infos = _.get(purshaseProduct,'members.[0].infos');
                if(infos){
                  // Sem nome de equipe cadastrado: use o nome do 1º atleta.
                  // Nunca use respostas array/objeto (ex.: "trechos": ["1","3","5"])
                  // nem booleanos como se fossem nome da equipe.
                  teamname = _.get(infos,'name','');
                  if( _.isEmpty(teamname) ){
                    _.forOwn(infos, (v,k)=>{
                      if( _.isString(v) && !_.isEmpty(v) && _.isEmpty(teamname) )
                        teamname = v;
                    })
                  }
                }
              }

              purshaseProduct._teamname = teamname;


              if(purshaseProduct.canceledByAdmin === true){
                purshaseProduct.paymentStatus="canceled"
              }



              purshaseProduct.product = getters.productForPurshaseProduct(purshaseProduct.productId)//rootGetters['EventStore/getProductById'](purshaseProduct.productId)
              return purshaseProduct;
          })

          return _.sortBy(registrations,['id']).reverse();
        
      },

      purshaseProductById: ( state, getters, rootState, rootGetters ) => id => {
        let purchaseProducts = getters.myRegistrations;
        //debugger;
        return _.find(purchaseProducts,{id})
      },

      purshaseProductsForCurrentOrder: ( state, getters, rootState, rootGetters ) =>{
          var order = getters.currentOrder;
          if(order){
            let purshaceProducts = _.filter(state.purshaceProducts, {orderId:order.id} )   
            return _.map( purshaceProducts, purshaseProduct =>{
              purshaseProduct = {...purshaseProduct}
              purshaseProduct.members = getters.membersForPurshaseProduct(purshaseProduct.id)
              purshaseProduct.team = getters.teamForPurshaseProduct(purshaseProduct.id)
              purshaseProduct.product = rootGetters['EventStore/getProductById'](purshaseProduct.productId)
              return purshaseProduct;
            })
          }else{
            return false
          }
      },
      
      purshaseProductsForProductId: ( state, getters, rootState, rootGetters ) => productId => {
          let purchaseProducts = getters.purshaseProductsForCurrentOrder;
          return _.filter(purchaseProducts,{productId})
      },

      membersForPurshaseProduct: (state)=> (purchaseProductId) =>{
            purchaseProductId = _.get(purchaseProductId,'id',purchaseProductId);
            return _.filter(state.members, {purchaseProductId} )
      },
      productForPurshaseProduct: (state)=> (productId) =>{
            return state.products[productId]
      },

      teamForPurshaseProduct: (state)=> (purchaseProductId) =>{
            purchaseProductId = _.get(purchaseProductId,'id',purchaseProductId);
            return _.filter(state.teams, {purchaseProductId} )
      },

      memberByID: (state, getters, rootState, rootGetters) => (memberId) =>{
        memberId = _.get(memberId,'id',memberId);
        let member = _.find(state.members, {id: memberId} );
        if(member){
            member = {...member}
           let purshaseProduct = getters.purshaseProductById(member.purchaseProductId)
            member.product = purshaseProduct.product;
            member.questions =  purshaseProduct.product.memberInfos;
            member.memberInfos =  purshaseProduct.product.memberInfos;
            return member;
        }else{
          return false
        }
      },

      teamByID: (state, getters, rootState, rootGetters) => (teamId) =>{
        teamId = _.get(teamId,'id',teamId);
        let team = _.find(state.teams, {id: teamId} );
        if(team){
           team = {...team}
            let purshaseProduct = getters.purshaseProductById(team.purchaseProductId)
            team.product = purshaseProduct.product;
            team.questions =  purshaseProduct.product.teamInfos;
            team.teamInfos =  purshaseProduct.product.teamInfos;
            return team;
        }else{
          return false  
        }
      },


      status: state => state.status, 
      statusError: state => state.statusError, 

      // purshaseProductById: (state, getters, rootState, rootGetters) => purchaseProductId => {
      //   purchaseProductId = _.get(purchaseProductId,'id',purchaseProductId);
      //   let purchaseProduct = state.purshaceProducts[purchaseProductId]
      //   let product = rootGetters['EventStore/getProductById'](purchaseProduct.productId)
      //   purchaseProduct = {...purchaseProduct}
      //   purchaseProduct.product = product
      //   return purchaseProduct
      // },

      getProductsForCurrentOrder: (state, getters, rootState, rootGetters) => {
        let purchaseProducts = getters.purshaseProductsForCurrentOrder
        return _.map(purchaseProducts,ps=>{
          return ps.product
        })
      },

      paymentOptionSelected:function(state){
        return state.paymentOptionSelected;
      },

      paymentInfo:function(state){
        return state.paymentInfo;
      }


    }

  }
}
